import { Component } from '@angular/core'
import { environment } from "../../../../../environments/environment";

@Component({
    selector: 'cui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  public year: number = new Date().getFullYear()
  public applicationName: string = environment.copyright.application
  public companyName: string = environment.copyright.company
  public companyUrl: string = environment.copyright.url
}
